import { Row, Col, Card, Typography, Space } from 'antd';
import { Check, X } from 'lucide-react';

const { Title, Text } = Typography;

export function Problem() {
  const negatives = [
    'Custom billing logic',
    'Manual feature checks',
    'Complex entitlement management',
    'User access issues',
    'API limit enforcement',
    'Months of development',
  ];

  const positives = [
    'Ready-to-use subscription engine',
    'Feature access management',
    'Usage-based billing',
    'Tenant isolation',
    'API key management',
    'Launch in days',
  ];

  return (
    <section style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <Title
            level={2}
            style={{
              fontSize: 'clamp(24px, 3.5vw, 36px)',
              color: '#1f1f1f',
              margin: 0,
              fontWeight: 700,
            }}
          >
            Building Subscription Infrastructure Yourself Is Expensive
          </Title>
        </div>

        <Row gutter={[32, 32]}>
          {/* Without iSubscribe */}
          <Col xs={24} md={12}>
            <Card
              variant="borderless"
              styles={{
                body: {
                  background: '#fff1f0',
                  borderRadius: '12px',
                  border: '2px solid #ffccc7',
                  padding: '32px',
                  height: '100%',
                },
              }}
            >
              <Title
                level={3}
                style={{
                  color: '#cf1322',
                  margin: '0 0 24px 0',
                  fontSize: '20px',
                  fontWeight: 700,
                }}
              >
                Without iSubscribe
              </Title>
              <Space
                orientation="vertical"
                size="middle"
                style={{ width: '100%' }}
              >
                {negatives.map((item) => (
                  <div
                    key={item}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px',
                    }}
                  >
                    <X
                      size={18}
                      style={{
                        color: '#ff4d4f',
                        flexShrink: 0,
                        marginTop: '2px',
                      }}
                    />
                    <Text style={{ color: '#434343', fontSize: '15px' }}>
                      {item}
                    </Text>
                  </div>
                ))}
              </Space>
            </Card>
          </Col>

          {/* With iSubscribe */}
          <Col xs={24} md={12}>
            <Card
              variant="borderless"
              styles={{
                body: {
                  background: '#f6ffed',
                  borderRadius: '12px',
                  border: '2px solid #b7eb8f',
                  padding: '32px',
                  height: '100%',
                },
              }}
            >
              <Title
                level={3}
                style={{
                  color: '#389e0d',
                  margin: '0 0 24px 0',
                  fontSize: '20px',
                  fontWeight: 700,
                }}
              >
                With iSubscribe
              </Title>
              <Space
                orientation="vertical"
                size="middle"
                style={{ width: '100%' }}
              >
                {positives.map((item) => (
                  <div
                    key={item}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px',
                    }}
                  >
                    <Check
                      size={18}
                      style={{
                        color: '#52c41a',
                        flexShrink: 0,
                        marginTop: '2px',
                      }}
                    />
                    <Text style={{ color: '#434343', fontSize: '15px' }}>
                      {item}
                    </Text>
                  </div>
                ))}
              </Space>
            </Card>
          </Col>
        </Row>
      </div>
    </section>
  );
}
